export default "__VITE_ASSET__d9134e70__"